module.exports = __webpack_public_path__ + "media/images/img_operator_2-d6a8588665116cdec2c16b2b4cbecb14.png";